/**
 * Created by anatoly on 13.01.2025
 */

const Merge2Generator = function (unit, options) {
    UnitComponent.call(this, unit);

    this.data = this.unit.getData().generator;
    this.autoMine = this.data.autoMine;

    this.mined = options.mined || 0;
    this.lockTime = options.lockTime || 0;
    this.boosters = {};
    Object.keys(GeneratorBoosterComponent.TYPES).forEach((type) => {
        this.boosters[type] = options[type] || 0;
    });

    if (this.lockTime > Date.now()) {
        this.lockTime = Date.now();
        this.unit.save();
    }

    if (this.lockTime > 0 && this.isRestorable()) {
        this.startRestore();
    }

    // console.log("this.mined", this.unit.code, this.mined, this.getRestoreTimeLeft() / 1000);

    if (this.data.energy) {
        cleverapps.lives.on("changeAmount", this.onUpdateState.bind(this), this);
        Merge2.current.generatorMultiplier.on("change", this.onUpdateState.bind(this), this);
    }

    if (this.autoMine) {
        Merge2.current.counter.registerStage(63, Merge2Generator.process);
    }

    this.onNeedToBeRemoved();
};

Merge2Generator.prototype = Object.create(UnitComponent.prototype);
Merge2Generator.prototype.constructor = Merge2Generator;

Merge2Generator.prototype.destructor = function () {
    runCleaners(this);

    if (this.restoreTimeout) {
        clearTimeout(this.restoreTimeout);
        delete this.restoreTimeout;
    }
};

Merge2Generator.prototype.onNeedToBeRemoved = function () {
    if (this.isCompleted() && !this.isRestorable()) {
        Field.mapEvent(Field.MINE, { affected: this.unit });

        this.unit.onDestruction();
        this.unit.remove(true);
    }
};

Merge2Generator.prototype.isRestorable = function () {
    if (this.isDestroyable()) {
        return false;
    }
    return this.data.cooldown !== undefined;
};

Merge2Generator.prototype.isDestroyable = function () {
    return Boolean(this.data.destroyAfterDrops);
};

Merge2Generator.prototype.isFresh = function () {
    return this.mined === 0;
};

Merge2Generator.prototype.getRestoreCooldown = function () {
    if (this.data.cooldown) {
        return cleverapps.parseInterval(this.data.cooldown);
    }
};

Merge2Generator.prototype.handleClick = function () {
    const activeUnit = Merge2.current.field.lastSelection;

    if (!activeUnit || this.unit.x !== activeUnit.x || this.unit.y !== activeUnit.y) {
        return false;
    }

    this.startMine();
    return true;
};

Merge2Generator.prototype.save = function (data) {
    if (this.mined) {
        data.mined = this.mined;
    }

    if (this.lockTime) {
        data.lockTime = this.lockTime;
    }

    Object.keys(this.boosters).forEach((type) => {
        if (this.boosters[type]) {
            data[type] = this.boosters[type];
        }
    });
};

Merge2Generator.prototype.getBoosterCharges = function (type) {
    return this.boosters[type] || 0;
};

Merge2Generator.prototype.hasBooster = function (type) {
    return this.getBoosterCharges(type) > 0;
};

Merge2Generator.prototype.isAmplified = function () {
    return this.hasBooster("amplifier");
};

Merge2Generator.prototype.isEnergyFree = function () {
    return this.hasBooster("energycard");
};

Merge2Generator.prototype.getBoosterCost = function () {
    return this.data.energy ? this.getSpawnEnergy() : 1;
};

Merge2Generator.prototype.getEnergyCost = function () {
    return Math.max(0, this.getSpawnEnergy() - this.getBoosterCharges("energycard"));
};

Merge2Generator.prototype.addBooster = function (type, charges) {
    this.boosters[type] += charges;
    this.unit.save();
    this.onUpdateState();
    Merge2.current.field.updateUnitSelection();
};

Merge2Generator.prototype.spendBoosters = function () {
    const cost = this.getBoosterCost();
    Object.keys(this.boosters).forEach((type) => {
        this.boosters[type] = Math.max(0, this.boosters[type] - cost);
    });

    Merge2.current.field.updateUnitSelection();
};

Merge2Generator.prototype.getRestoreTimeLeft = function () {
    if (!this.lockTime) {
        return 0;
    }
    const total = this.getRestoreCooldown();
    const timePassed = Date.now() - this.lockTime;
    return Math.max(0, total - timePassed);
};

Merge2Generator.prototype.isRestoring = function () {
    return this.restoreTimeout !== undefined;
};

Merge2Generator.prototype.startRestore = function () {
    const timeLeft = this.getRestoreTimeLeft();

    if (timeLeft > 0) {
        this.restoreTimeout = new cleverapps.LongTimeout(this.restore.bind(this), timeLeft);
        this.onUpdateState();
    } else {
        this.restore();
    }
};

Merge2Generator.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }

    if (Merge2.current && Merge2.current.field.selectedUnit === this.unit) {
        Merge2.current.field.updateUnitSelection();
    }
};

Merge2Generator.prototype.onCompleteMine = function () {
    if (this.view) {
        this.view.completeMine();
    }
};

Merge2Generator.prototype.setDimmingDisabled = function (disabled) {
    if (this.view) {
        this.view.setDimmingDisabled(disabled);
    }
};

Merge2Generator.prototype.restore = function () {
    delete this.lockTime;
    if (this.restoreTimeout) {
        clearTimeout(this.restoreTimeout);
        delete this.restoreTimeout;
    }

    this.mined = 0;
    this.unit.save();
    this.onUpdateState();

    cleverapps.tutorial.trigger("onGeneratorRestored");
};

Merge2Generator.prototype.isCompleted = function () {
    return this.mined >= this.data.spawn;
};

Merge2Generator.prototype.speedUp = function () {
    this.restore();

    if (this.view) {
        this.view.onSpeedUp(() => {
            if (this.autoMine) {
                Merge2.current.counter.trigger();
            }
        });
    }
};

Merge2Generator.prototype.reduceCooldown = function (duration) {
    if (!this.isRestoring()) {
        return;
    }

    this.lockTime -= duration;

    if (this.getRestoreTimeLeft() === 0) {
        this.speedUp();
        return;
    }

    clearTimeout(this.restoreTimeout);
    delete this.restoreTimeout;

    this.unit.save();

    if (this.view) {
        this.view.onReduceCooldown();
    }

    this.startRestore();
};

Merge2Generator.prototype.getSpeedUpOptions = function () {
    return {
        timeLeft: this.getRestoreTimeLeft(),
        totalDuration: this.getRestoreCooldown(),
        callback: this.speedUp.bind(this),
        source: this.unit.onGetView(),
        isFree: !cleverapps.forces.isShown(Forces.GENERATOR_SPEED_UP)
    };
};

Merge2Generator.prototype.getLuckyBonus = function (code) {
    let luck = PseudoRandom.GET().nextDouble();
    if (cleverapps.config.debugMode && Merge2Generator.debugNextLucky) {
        luck = 0;
    }

    if (luck > 0.015 || !Merge2Generator.LuckyDrops[code] || !cleverapps.user.checkAvailable(cleverapps.config.availables.LUCKY_DROP)) {
        return 0;
    }
    
    return Merge2Generator.LuckyDrops[code] || 0;
};

Merge2Generator.resetNextLuckyTool = function () {
    const game = cleverapps.Tool.game;
    const handler = game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];
    if (handler) {
        delete game[`${ToolMenuItem.ACTIVE_ITEM}nextLucky`];
        game.nextLucky = handler;
        cleverapps.toolModel.refresh();
    }
};

Merge2Generator.prototype.listPrize = function () {
    const drop = this.data.drop;
    const probabilities = this.data.weights || drop.map(() => 1 / drop.length);

    let power = this.data.power / 100;

    if (this.data.energy) {
        power += Math.log2(this.getMultiplier());
    }

    if (this.isAmplified()) {
        power += 1;
    }

    const powerMin = Math.floor(power);

    const units = [];

    drop.forEach((code) => {
        const maxStage = Families[code].units.length - 1;

        const luckyBonus = this.getLuckyBonus(code);

        if (luckyBonus) {
            cleverapps.playSession.logEvent(cleverapps.EVENTS.LUCKY_DROP);
        }

        const stage1 = Math.min(powerMin + luckyBonus - 1, maxStage);
        const stage2 = Math.min(stage1 + 1, maxStage);

        const p2 = power - powerMin;

        const stage = (PseudoRandom.GET().nextDouble() < p2) ? stage2 : stage1;

        units.push({ code, stage, gift: luckyBonus > 0 });
    });

    if (cleverapps.config.debugMode && Merge2Generator.debugNextLucky) {
        delete Merge2Generator.debugNextLucky;
        Merge2Generator.resetNextLuckyTool();
    }

    return [units[PseudoRandom.GET().pickOne(probabilities)]];
};

Merge2Generator.prototype.getMultiplier = function () {
    if (Unit.isSideQuest(this.unit.code)) {
        return GeneratorMultiplier.VALUES.X1;
    }

    let value = Merge2.current.generatorMultiplier.getValue();

    if (this.data.energy && this.isAmplified()) {
        const charges = this.getBoosterCharges("amplifier");
        while (value > GeneratorMultiplier.VALUES.X1 && charges < this.data.energy * value) {
            value /= 2;
        }
    }

    return value;
};

Merge2Generator.prototype.getSpawnEnergy = function () {
    return this.data.energy * this.getMultiplier();
};

Merge2Generator.prototype.canMine = function () {
    if (this.isCompleted()) {
        return false;
    }

    return !this.unit.isDragged();
};

Merge2Generator.prototype.hasEnoughEnergy = function () {
    return !this.data.energy || cleverapps.lives.canTake(this.getEnergyCost());
};

Merge2Generator.prototype.canStartMine = function () {
    return this.canMine() && this.hasEnoughEnergy() && Merge2.current.field.countEmptySlots() > 0;
};

Merge2Generator.prototype.startMine = function () {
    if (!this.canStartMine()) {
        this.rejectMine();
        return false;
    }

    if (this.data.energy && this.getEnergyCost() > 0) {
        Merge2.current.useEnergy(this.getEnergyCost(), this.unit);
    }

    Merge2.current.field.updateUnitSelection();

    this.completeMine();
    return true;
};

Merge2Generator.prototype.rejectMine = function () {
    if (this.isCompleted() && this.isRestoring()) {
        Merge2.current.showGeneratorCooldownHint(this.unit.view);
    }

    if (!this.canMine()) {
        this.unit.squeeze();
        cleverapps.effects.fire("merge2.board.full");
        return;
    }

    if (Merge2.current.field.countEmptySlots() === 0) {
        Merge2.current.showNoSpaceHint(this.unit.view);
        cleverapps.effects.fire("merge2.board.full");
        return;
    }

    Merge2.current.confirmEnoughEnergy(this.getEnergyCost());
    Merge2.current.showHint(this.unit.view, Messages.get("NoEnergy"));
    cleverapps.effects.fire("merge2.generator.off");
};

Merge2Generator.prototype.completeMine = function () {
    const silent = Merge2.current.autoPlay && Merge2.current.autoPlay.isRunning;

    cleverapps.tutorial.trigger("mine");

    const rewards = this.listPrize();
    const gift = rewards.some((r) => r.gift);

    Merge2.current.spawn(rewards, this.unit, { silent, gift });

    let mined = 1;
    if (!this.isRestorable()) {
        mined *= this.getMultiplier();
    }

    this.mined += mined;

    this.spendBoosters();

    if (this.isRestorable() && !this.isRestoring()) {
        this.lockTime = Date.now();
        this.startRestore();
    }

    this.unit.save();

    this.onUpdateState();
    this.onCompleteMine();
    this.onNeedToBeRemoved();
};

Merge2Generator.prototype.isActive = function () {
    return this.hasEnoughEnergy() && !(this.isCompleted() && this.isRestoring());
};

Merge2Generator.getEmptyNeighbors = function (x, y) {
    return BorderRenderer.getNeighbours(x, y).filter(
        (neighbor) => Merge2.current.field.isValid(neighbor.x, neighbor.y) && Merge2.current.field.isEmpty(neighbor.x, neighbor.y)
    );
};

Merge2Generator.process = function () {
    if (cleverapps.tutorial.isActive()) {
        return;
    }

    const units = Merge2.current.field.listAvailableUnits((unit) => {
        const generator = unit.findComponent(Merge2Generator);
        if (generator && generator.autoMine && generator.canMine() && Merge2Generator.getEmptyNeighbors(unit.x, unit.y).length > 0) {
            return true;
        }
    });

    const generator = units[0] && units[0].findComponent(Merge2Generator);
    if (generator) {
        generator.startMine();
    }
};

Merge2Generator.LuckyDrops = {
    a: 3, c: 3, e: 3, b: 2, d: 2, g: 2, i: 2
};
